import dateAndTimeConstants from './dateAndTime.json';

export const getDateAndTimeConstants = data => dateAndTimeConstants[data];